import * as React from 'react';
import { Col, Radio, Row } from 'antd';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { TextView } from '../../../core/ui/text.view';
import { SearchOccupancyView } from '../search/search-occupancy.view';
import { SupplierEditorController } from '../../products/suppliers/parts/supplier-editor.controller';

interface Props extends ComponentViewProps<ProductManually> {
	paxes: PersonOccupancy[];
	quote: QuoteItem;
	entries: QuoteEntryItem[];
	currencyCode: string;
}

interface State {
	type: number;
	value: number;
}

@observer
export class SalesAdjustmentManuallyView extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			type: 0,
			value: 0
		};
	}

	private updateSellPrice(): void {
		const { model, quote, entries } = this.props;
		const { type, value } = this.state;

		const salesAdjustment = entries.find(e => e.productType === 7);
		const oldAdjustment = parseFloat((salesAdjustment ? salesAdjustment.sellPrice : 0).toString());
		switch (type) {
			case 0:
				const diff = value - quote.totalSaleGross + oldAdjustment;
				model.sellPrice = diff;
				break;
			case 1:
				model.sellPrice = oldAdjustment + value;
				break;
			case 2:
				model.sellPrice = oldAdjustment - value;
				break;
		}

		model.sellPriceResult = {
			currencyIsoCode: model.sellPriceResult.currencyIsoCode,
			exchangeRate: 1,
			isCommissionable: false,
			isPriceLive: true,
			sourceCurrencyIsoCode: model.sellPriceResult.currencyIsoCode,
			totalPrice: model.sellPrice,
			breakdown: [
				{
					exchangeRate: 1,
					percent: false,
					price: model.sellPrice,
					priceType: 'PerUnit',
					unitPrice: model.sellPrice
				}
			],
			paxs: model.occupancies.map(e => e.id)
		};
	}

	@autobind
	private handleChangeType(ev): void {
		this.setState({
			type: ev.target.value,
		}, this.updateSellPrice);
	}

	@autobind
	private handleChangeAmount(ev): void {
		this.setState({
			value: parseFloat(ev),
		}, this.updateSellPrice);
	}

	renderProductManually(model: ProductManually, paxes: any[], occupancy: PersonOccupancy[]): React.ReactNode {
		if (model.productType < 0) {
			return null;
		}
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} md={12}>
						<SupplierEditorController
							required
							label="Supplier"
							mode="edit"
							supplierType={model.productType == 2 ? 1 : 0}
							onChange={(value: SupplierSummary) => {
								model.supplierId = value ? value.id : null;
								model.supplierTitle = value ? value.title : "";
							}}
							value={model.supplierId}
							setBusy={this.props.setBusy}
						/>
						<TextView
							required
							label="Current sell price"
							mode="display"
							value={this.props.quote.totalSaleGross}
							suffix={this.props.currencyCode}
						/>
						<TextView
							required
							label="Amount"
							mode="edit"
							value={this.state.value}
							onChanged={this.handleChangeAmount}
							suffix={this.props.currencyCode}
						/>
						<br />
						<Radio.Group
							onChange={this.handleChangeType}
							value={this.state.type}>
							<Radio value={0}>Change price to</Radio>
							<Radio value={1}>Increse by</Radio>
							<Radio value={2}>Decrease by</Radio>
						</Radio.Group>
					</Col>
				</Row>
				<br />
				<SearchOccupancyView
					type="General"
					occupancies={[{ unit: 1, paxs: occupancy }]}
					setBusy={this.props.setBusy}
					paxs={paxes}
					lockUnits={true}
				/>
			</React.Fragment>
		);
	}

	render(): React.ReactNode {
		if (this.props.model == null) {
			return null;
		}

		return this.renderProductManually(this.props.model, this.props.paxes, this.props.model.occupancies);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/product-manually/sales-adjustment-manually.view.tsx